import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  TextField,
  Chip,
  FormControlLabel,
  Switch,
  Button,
  Stack,
} from "@material-ui/core";
import { ESTADOS_EMPLEADO } from "./hooks/useEmpleadosFilters";

const ROLES_DISPONIBLES = [
  "SUPER_ADMIN",
  "ADMIN",
  "ADMIN_OPERACIONES",
  "SUPERVISOR",
  "EMPLEADO",
];

const BarraFiltrosEmpleados = ({ filtros, updateFiltro, limpiarFiltros }) => {
  const toggleEnArray = (campo, valor) => {
    const actual = filtros[campo] || [];
    const nuevo = actual.includes(valor)
      ? actual.filter((v) => v !== valor)
      : [...actual, valor];
    updateFiltro(campo, nuevo);
  };

  const hayFiltrosActivos =
    filtros.busqueda ||
    filtros.estados.length > 0 ||
    filtros.roles.length > 0 ||
    filtros.sinFoto;

  return (
    <Box sx={{ p: 2, borderBottom: "1px solid #eee" }}>
      <TextField
        fullWidth
        placeholder="Buscar por nombre, apellidos, RUT, correo o cargo..."
        value={filtros.busqueda}
        onChange={(e) => updateFiltro("busqueda", e.target.value)}
        size="small"
        sx={{ mb: 2 }}
      />

      <Stack direction="row" spacing={2} sx={{ flexWrap: "wrap", gap: 1 }}>
        {/* Estado */}
        <Box>
          <Box
            component="span"
            sx={{
              fontSize: 11,
              color: "text.secondary",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              mr: 1,
            }}
          >
            Estado:
          </Box>
          {ESTADOS_EMPLEADO.map((e) => (
            <Chip
              key={e.value}
              label={e.label}
              size="small"
              clickable
              color={filtros.estados.includes(e.value) ? "primary" : "default"}
              variant={
                filtros.estados.includes(e.value) ? "filled" : "outlined"
              }
              onClick={() => toggleEnArray("estados", e.value)}
              sx={{ mr: 0.5 }}
            />
          ))}
        </Box>

        {/* Rol */}
        <Box>
          <Box
            component="span"
            sx={{
              fontSize: 11,
              color: "text.secondary",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              mr: 1,
            }}
          >
            Rol:
          </Box>
          {ROLES_DISPONIBLES.map((r) => (
            <Chip
              key={r}
              label={r}
              size="small"
              clickable
              color={filtros.roles.includes(r) ? "primary" : "default"}
              variant={filtros.roles.includes(r) ? "filled" : "outlined"}
              onClick={() => toggleEnArray("roles", r)}
              sx={{ mr: 0.5 }}
            />
          ))}
        </Box>

        {/* Sin foto */}
        <FormControlLabel
          control={
            <Switch
              checked={filtros.sinFoto}
              onChange={(e) => updateFiltro("sinFoto", e.target.checked)}
            />
          }
          label="Sin foto"
        />

        {hayFiltrosActivos && (
          <Button size="small" onClick={limpiarFiltros}>
            Limpiar filtros
          </Button>
        )}
      </Stack>
    </Box>
  );
};

BarraFiltrosEmpleados.propTypes = {
  filtros: PropTypes.object.isRequired,
  updateFiltro: PropTypes.func.isRequired,
  limpiarFiltros: PropTypes.func.isRequired,
};

export default BarraFiltrosEmpleados;
